import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import LoginSso from './LoginSso';

const mode = process.env.REACT_APP_MODE;

const RequireAuth = () => {
  const { auth } = useContext(AuthContext);
  const location = useLocation();

  if (auth?.token && auth?.roleNames) {
    localStorage.removeItem('auth');
    return <LoginSso />;
  }

  if (mode === 'development') {
    return auth?.token ? (
      <Outlet />
    ) : (
      <Navigate to="/auth/login" state={{ from: location }} replace />
    );
  }

  if (mode === 'production') {
    return auth?.token ? <Outlet /> : <LoginSso />;
  }

  return null;
};

export default RequireAuth;
